import { TraitTypeText } from '../traitTypes/TraitTypeText';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
import { TraitTypeNumeric } from '../traitTypes/TraitTypeNumeric';
export class TraitRegistryCssFlex extends TraitRegistryCategory {
    label = 'Flex';
    constructor(parent) {
        super(parent);
        super.init();
    }
    display = () => new TraitTypeSelect({
        init: 'flex',
        default: 'inline' /*
      label: 'Display',
      select: [
        ['none', 'Nicht anzeigen'],
        ['flex', 'FlexContainer'],
        ['block', 'Als Block'],
        ['inline-block', 'Block in Zeile'],
        ['inline', 'In Zeile']
      ] */
    });
    flexDirection = () => new TraitTypeSelect({
        default: 'row' /*
      label: 'Richtung',
      select: [['row', '→'], ['column', '↓'], ['row-reverse', '←'], ['column-reverse', '↑']] */
    });
    flexWrap = () => new TraitTypeSelect({
        default: 'nowrap' /*
      label: 'FlexWrap',
      select: [['nowrap', 'nowrap'], ['wrap', 'wrap'], ['wrap-reverse', 'wrap-reverse']] */
    });
    justifyContent = () => new TraitTypeSelect({
        default: 'flex-start' /*
        label: 'Ausrichtung im Block',
      select: [
        ['flex-start', 'Anfang'],
        ['flex-end', 'Ende'],
        ['center', 'Mitte'],
        ['space-between', 'Platz dazwischen'],
        ['space-around', 'Platz außenrum']
      ] */
    });
    alignItems = () => new TraitTypeSelect({
        default: 'flex-start'
        /*
          label: 'Ausrichtung im Block quer',
        select: [
          ['flex-start', 'Anfang'],
          ['flex-end', 'Ende'],
          ['center', 'Mitte'],
          ['stretch', 'Strecken'],
          ['baseline', 'Grundlinie']
        ] */
    });
    alignSelf = () => new TraitTypeSelect({
        default: 'auto'
        /* label: 'Eigenausrichtung',
        select: [
          ['auto', 'Auto'],
          ['flex-start', 'Oben'],
          ['flex-end', 'Unten'],
          ['center', 'Mitte'],
          ['baseline', 'Grundlinie'],
          ['stretch', 'Strecken']
        ] */
    });
    alignContent = () => new TraitTypeSelect({
        default: 'flex-start'
        /*
        label: 'Mehrzeilig Ausr.',
        select: [
          ['flex-start', 'Start'],
          ['flex-end', 'Ende'],
          ['center', 'Mitte'],
          ['stretch', 'gestreckt'],
          ['space-between', 'space-between'],
          ['space-around', 'space-around']
        ] */
    });
    /* Flex item */
    flex = () => new TraitTypeSelectWithPreview({
        default: '0 1 auto' /*
      label: 'Flex',
      select: [['1 1 auto', 'Wachsen'], ['0 1 auto', 'Nicht wachsen'], ['none', 'Kein']] */
    });
    order = () => new TraitTypeNumeric({
        label: 'Display',
        min: 0,
        max: 100,
        default: 0
    });
    flexGrow = () => new TraitTypeNumeric({
        label: 'Wachsen',
        min: 0,
        max: 20,
        default: 0
    });
    flexShrink = () => new TraitTypeNumeric({
        label: 'Schrumpfen',
        min: 0,
        max: 20,
        default: 1
    });
    flexBasis = () => new TraitTypeText({
        label: 'Basis',
        default: 'auto'
    });
}
